var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF0000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.691 12.6433C23.5181 12.0008 23.0115 11.4942 22.369 11.3213C21.1952 11 16.5 11 16.5 11C16.5 11 11.8048 11 10.631 11.3089C10.0008 11.4819 9.48188 12.0008 9.30889 12.6433C9 13.8171 9 16.2512 9 16.2512C9 16.2512 9 18.6977 9.30889 19.8591C9.48188 20.5016 9.98846 21.0082 10.631 21.1812C11.8171 21.5024 16.5 21.5024 16.5 21.5024C16.5 21.5024 21.1952 21.5024 22.369 21.1935C23.0115 21.0206 23.5181 20.514 23.691 19.8715C23.9999 18.6977 23.9999 16.2636 23.9999 16.2636C23.9999 16.2636 24.0123 13.8171 23.691 12.6433Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0049 18.5L18.9093 16.2512L15.0049 14.0024V18.5Z",
    fill: "#FF0000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/YT.719aac5fdd643e2ef9285c60fc6617e3.svg";
export { ForwardRef as ReactComponent };